var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInventoryManagementStorageImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8571 29.6154H2.64286V2.69231H12.1175L16.6368 7.28269L17.4032 8.07692H34.3571V18.8462H37V8.07692C37 7.36288 36.7216 6.67808 36.2259 6.17318C35.7303 5.66827 35.0581 5.38462 34.3571 5.38462H18.5L13.9939 0.794232C13.7481 0.542274 13.4557 0.342378 13.1336 0.206066C12.8116 0.0697529 12.4662 -0.000280662 12.1175 8.45294e-07H2.64286C1.94193 8.45294e-07 1.26971 0.283654 0.774075 0.788559C0.278443 1.29347 0 1.97826 0 2.69231V29.6154C0 30.3294 0.278443 31.0142 0.774075 31.5191C1.26971 32.024 1.94193 32.3077 2.64286 32.3077H15.8571V29.6154Z",
    fill: "url(#paint0_linear_441_1315)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_441_1315",
    x1: 18.5,
    y1: 0,
    x2: 18.5,
    y2: 32.3077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryManagementStorageImg);
export default __webpack_public_path__ + "static/media/inventory_management_storage_img.ecc9515a559a023da89c59b57505acbe.svg";
export { ForwardRef as ReactComponent };